// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.holder {
  position: absolute;
  left: 0px;
  top: 0px;
  bottom: 0px;
  right: 0px;
  width: 100%;
  height: 100%;
  background-color: rgba(5, 45, 62, .7);
}
.preloader {
  width: 100px;
  height: 100px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
  animation: rotatePreloader 2s infinite ease-in;
}

.text {
  position: absolute;
  left: 50%;
  top: 60%;
  transform: translateX(-50%) translateY(-50%);
  color: #fff;
  font-family: NunitoSans,sans-serif;
  font-size: 12px;
  text-align: center;
}

@keyframes rotatePreloader {
  0% {
    transform: translateX(-50%) translateY(-50%) rotateZ(0deg);
 }
  100% {
    transform: translateX(-50%) translateY(-50%) rotateZ(-360deg);
 }
}
.preloader div {
  position: absolute;
  width: 100%;
  height: 100%;
  opacity: 0;
}
.preloader div:before {
  content: "";
  position: absolute;
  left: 50%;
  top: 0%;
  width: 10%;
  height: 10%;
  background-color: #fff;
  transform: translateX(-50%);
  border-radius: 50%;
}
.preloader div:nth-child(1) {
  transform: rotateZ(0deg);
  animation: rotateCircle1 2s infinite linear;
  z-index: 9;
}
@keyframes rotateCircle1 {
  0% {
    opacity: 0;
 }
  0% {
    opacity: 1;
    transform: rotateZ(36deg);
 }
  7% {
    transform: rotateZ(0deg);
 }
  57% {
    transform: rotateZ(0deg);
 }
  100% {
    transform: rotateZ(-324deg);
    opacity: 1;
 }
}
.preloader div:nth-child(2) {
  transform: rotateZ(36deg);
  animation: rotateCircle2 2s infinite linear;
  z-index: 8;
}
@keyframes rotateCircle2 {
  5% {
    opacity: 0;
 }
  5.0001% {
    opacity: 1;
    transform: rotateZ(0deg);
 }
  12% {
    transform: rotateZ(-36deg);
 }
  62% {
    transform: rotateZ(-36deg);
 }
  100% {
    transform: rotateZ(-324deg);
    opacity: 1;
 }
}
.preloader div:nth-child(3) {
  transform: rotateZ(72deg);
  animation: rotateCircle3 2s infinite linear;
  z-index: 7;
}
@keyframes rotateCircle3 {
  10% {
    opacity: 0;
 }
  10.0002% {
    opacity: 1;
    transform: rotateZ(-36deg);
 }
  17% {
    transform: rotateZ(-72deg);
 }
  67% {
    transform: rotateZ(-72deg);
 }
  100% {
    transform: rotateZ(-324deg);
    opacity: 1;
 }
}
.preloader div:nth-child(4) {
  transform: rotateZ(108deg);
  animation: rotateCircle4 2s infinite linear;
  z-index: 6;
}
@keyframes rotateCircle4 {
  15% {
    opacity: 0;
 }
  15.0003% {
    opacity: 1;
    transform: rotateZ(-72deg);
 }
  22% {
    transform: rotateZ(-108deg);
 }
  72% {
    transform: rotateZ(-108deg);
 }
  100% {
    transform: rotateZ(-324deg);
    opacity: 1;
 }
}
.preloader div:nth-child(5) {
  transform: rotateZ(144deg);
  animation: rotateCircle5 2s infinite linear;
  z-index: 5;
}
@keyframes rotateCircle5 {
  20% {
    opacity: 0;
 }
  20.0004% {
    opacity: 1;
    transform: rotateZ(-108deg);
 }
  27% {
    transform: rotateZ(-144deg);
 }
  77% {
    transform: rotateZ(-144deg);
 }
  100% {
    transform: rotateZ(-324deg);
    opacity: 1;
 }
}
.preloader div:nth-child(6) {
  transform: rotateZ(180deg);
  animation: rotateCircle6 2s infinite linear;
  z-index: 4;
}
@keyframes rotateCircle6 {
  25% {
    opacity: 0;
 }
  25.0005% {
    opacity: 1;
    transform: rotateZ(-144deg);
 }
  32% {
    transform: rotateZ(-180deg);
 }
  82% {
    transform: rotateZ(-180deg);
 }
  100% {
    transform: rotateZ(-324deg);
    opacity: 1;
 }
}
.preloader div:nth-child(7) {
  transform: rotateZ(216deg);
  animation: rotateCircle7 2s infinite linear;
  z-index: 3;
}
@keyframes rotateCircle7 {
  30% {
    opacity: 0;
 }
  30.0006% {
    opacity: 1;
    transform: rotateZ(-180deg);
 }
  37% {
    transform: rotateZ(-216deg);
 }
  87% {
    transform: rotateZ(-216deg);
 }
  100% {
    transform: rotateZ(-324deg);
    opacity: 1;
 }
}
.preloader div:nth-child(8) {
  transform: rotateZ(252deg);
  animation: rotateCircle8 2s infinite linear;
  z-index: 2;
}
@keyframes rotateCircle8 {
  35% {
    opacity: 0;
 }
  35.0007% {
    opacity: 1;
    transform: rotateZ(-216deg);
 }
  42% {
    transform: rotateZ(-252deg);
 }
  92% {
    transform: rotateZ(-252deg);
 }
  100% {
    transform: rotateZ(-324deg);
    opacity: 1;
 }
}
.preloader div:nth-child(9) {
  transform: rotateZ(288deg);
  animation: rotateCircle9 2s infinite linear;
  z-index: 1;
}
@keyframes rotateCircle9 {
  40% {
    opacity: 0;
 }
  40.0008% {
    opacity: 1;
    transform: rotateZ(-252deg);
 }
  47% {
    transform: rotateZ(-288deg);
 }
  97% {
    transform: rotateZ(-288deg);
 }
  100% {
    transform: rotateZ(-324deg);
    opacity: 1;
 }
}
.preloader div:nth-child(10) {
  transform: rotateZ(324deg);
  animation: rotateCircle10 2s infinite linear;
  z-index: 0;
}
@keyframes rotateCircle10 {
  45% {
    opacity: 0;
 }
  45.0009% {
    opacity: 1;
    transform: rotateZ(-288deg);
 }
  52% {
    transform: rotateZ(-324deg);
 }
  102% {
    transform: rotateZ(-324deg);
 }
  100% {
    transform: rotateZ(-324deg);
    opacity: 1;
 }
}
`, "",{"version":3,"sources":["webpack://./src/app/shared/component/loading/loading.component.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,WAAW;EACX,UAAU;EACV,WAAW;EACX,YAAY;EACZ,qCAAqC;AACvC;AACA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,4CAA4C;EAC5C,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,4CAA4C;EAC5C,WAAW;EACX,kCAAkC;EAClC,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE;IACE,0DAA0D;CAC7D;EACC;IACE,6DAA6D;CAChE;AACD;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,UAAU;EACV,WAAW;EACX,sBAAsB;EACtB,2BAA2B;EAC3B,kBAAkB;AACpB;AACA;EACE,wBAAwB;EACxB,2CAA2C;EAC3C,UAAU;AACZ;AACA;EACE;IACE,UAAU;CACb;EACC;IACE,UAAU;IACV,yBAAyB;CAC5B;EACC;IACE,wBAAwB;CAC3B;EACC;IACE,wBAAwB;CAC3B;EACC;IACE,2BAA2B;IAC3B,UAAU;CACb;AACD;AACA;EACE,yBAAyB;EACzB,2CAA2C;EAC3C,UAAU;AACZ;AACA;EACE;IACE,UAAU;CACb;EACC;IACE,UAAU;IACV,wBAAwB;CAC3B;EACC;IACE,0BAA0B;CAC7B;EACC;IACE,0BAA0B;CAC7B;EACC;IACE,2BAA2B;IAC3B,UAAU;CACb;AACD;AACA;EACE,yBAAyB;EACzB,2CAA2C;EAC3C,UAAU;AACZ;AACA;EACE;IACE,UAAU;CACb;EACC;IACE,UAAU;IACV,0BAA0B;CAC7B;EACC;IACE,0BAA0B;CAC7B;EACC;IACE,0BAA0B;CAC7B;EACC;IACE,2BAA2B;IAC3B,UAAU;CACb;AACD;AACA;EACE,0BAA0B;EAC1B,2CAA2C;EAC3C,UAAU;AACZ;AACA;EACE;IACE,UAAU;CACb;EACC;IACE,UAAU;IACV,0BAA0B;CAC7B;EACC;IACE,2BAA2B;CAC9B;EACC;IACE,2BAA2B;CAC9B;EACC;IACE,2BAA2B;IAC3B,UAAU;CACb;AACD;AACA;EACE,0BAA0B;EAC1B,2CAA2C;EAC3C,UAAU;AACZ;AACA;EACE;IACE,UAAU;CACb;EACC;IACE,UAAU;IACV,2BAA2B;CAC9B;EACC;IACE,2BAA2B;CAC9B;EACC;IACE,2BAA2B;CAC9B;EACC;IACE,2BAA2B;IAC3B,UAAU;CACb;AACD;AACA;EACE,0BAA0B;EAC1B,2CAA2C;EAC3C,UAAU;AACZ;AACA;EACE;IACE,UAAU;CACb;EACC;IACE,UAAU;IACV,2BAA2B;CAC9B;EACC;IACE,2BAA2B;CAC9B;EACC;IACE,2BAA2B;CAC9B;EACC;IACE,2BAA2B;IAC3B,UAAU;CACb;AACD;AACA;EACE,0BAA0B;EAC1B,2CAA2C;EAC3C,UAAU;AACZ;AACA;EACE;IACE,UAAU;CACb;EACC;IACE,UAAU;IACV,2BAA2B;CAC9B;EACC;IACE,2BAA2B;CAC9B;EACC;IACE,2BAA2B;CAC9B;EACC;IACE,2BAA2B;IAC3B,UAAU;CACb;AACD;AACA;EACE,0BAA0B;EAC1B,2CAA2C;EAC3C,UAAU;AACZ;AACA;EACE;IACE,UAAU;CACb;EACC;IACE,UAAU;IACV,2BAA2B;CAC9B;EACC;IACE,2BAA2B;CAC9B;EACC;IACE,2BAA2B;CAC9B;EACC;IACE,2BAA2B;IAC3B,UAAU;CACb;AACD;AACA;EACE,0BAA0B;EAC1B,2CAA2C;EAC3C,UAAU;AACZ;AACA;EACE;IACE,UAAU;CACb;EACC;IACE,UAAU;IACV,2BAA2B;CAC9B;EACC;IACE,2BAA2B;CAC9B;EACC;IACE,2BAA2B;CAC9B;EACC;IACE,2BAA2B;IAC3B,UAAU;CACb;AACD;AACA;EACE,0BAA0B;EAC1B,4CAA4C;EAC5C,UAAU;AACZ;AACA;EACE;IACE,UAAU;CACb;EACC;IACE,UAAU;IACV,2BAA2B;CAC9B;EACC;IACE,2BAA2B;CAC9B;EACC;IACE,2BAA2B;CAC9B;EACC;IACE,2BAA2B;IAC3B,UAAU;CACb;AACD","sourcesContent":[".holder {\n  position: absolute;\n  left: 0px;\n  top: 0px;\n  bottom: 0px;\n  right: 0px;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(5, 45, 62, .7);\n}\n.preloader {\n  width: 100px;\n  height: 100px;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translateX(-50%) translateY(-50%);\n  animation: rotatePreloader 2s infinite ease-in;\n}\n\n.text {\n  position: absolute;\n  left: 50%;\n  top: 60%;\n  transform: translateX(-50%) translateY(-50%);\n  color: #fff;\n  font-family: NunitoSans,sans-serif;\n  font-size: 12px;\n  text-align: center;\n}\n\n@keyframes rotatePreloader {\n  0% {\n    transform: translateX(-50%) translateY(-50%) rotateZ(0deg);\n }\n  100% {\n    transform: translateX(-50%) translateY(-50%) rotateZ(-360deg);\n }\n}\n.preloader div {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  opacity: 0;\n}\n.preloader div:before {\n  content: \"\";\n  position: absolute;\n  left: 50%;\n  top: 0%;\n  width: 10%;\n  height: 10%;\n  background-color: #fff;\n  transform: translateX(-50%);\n  border-radius: 50%;\n}\n.preloader div:nth-child(1) {\n  transform: rotateZ(0deg);\n  animation: rotateCircle1 2s infinite linear;\n  z-index: 9;\n}\n@keyframes rotateCircle1 {\n  0% {\n    opacity: 0;\n }\n  0% {\n    opacity: 1;\n    transform: rotateZ(36deg);\n }\n  7% {\n    transform: rotateZ(0deg);\n }\n  57% {\n    transform: rotateZ(0deg);\n }\n  100% {\n    transform: rotateZ(-324deg);\n    opacity: 1;\n }\n}\n.preloader div:nth-child(2) {\n  transform: rotateZ(36deg);\n  animation: rotateCircle2 2s infinite linear;\n  z-index: 8;\n}\n@keyframes rotateCircle2 {\n  5% {\n    opacity: 0;\n }\n  5.0001% {\n    opacity: 1;\n    transform: rotateZ(0deg);\n }\n  12% {\n    transform: rotateZ(-36deg);\n }\n  62% {\n    transform: rotateZ(-36deg);\n }\n  100% {\n    transform: rotateZ(-324deg);\n    opacity: 1;\n }\n}\n.preloader div:nth-child(3) {\n  transform: rotateZ(72deg);\n  animation: rotateCircle3 2s infinite linear;\n  z-index: 7;\n}\n@keyframes rotateCircle3 {\n  10% {\n    opacity: 0;\n }\n  10.0002% {\n    opacity: 1;\n    transform: rotateZ(-36deg);\n }\n  17% {\n    transform: rotateZ(-72deg);\n }\n  67% {\n    transform: rotateZ(-72deg);\n }\n  100% {\n    transform: rotateZ(-324deg);\n    opacity: 1;\n }\n}\n.preloader div:nth-child(4) {\n  transform: rotateZ(108deg);\n  animation: rotateCircle4 2s infinite linear;\n  z-index: 6;\n}\n@keyframes rotateCircle4 {\n  15% {\n    opacity: 0;\n }\n  15.0003% {\n    opacity: 1;\n    transform: rotateZ(-72deg);\n }\n  22% {\n    transform: rotateZ(-108deg);\n }\n  72% {\n    transform: rotateZ(-108deg);\n }\n  100% {\n    transform: rotateZ(-324deg);\n    opacity: 1;\n }\n}\n.preloader div:nth-child(5) {\n  transform: rotateZ(144deg);\n  animation: rotateCircle5 2s infinite linear;\n  z-index: 5;\n}\n@keyframes rotateCircle5 {\n  20% {\n    opacity: 0;\n }\n  20.0004% {\n    opacity: 1;\n    transform: rotateZ(-108deg);\n }\n  27% {\n    transform: rotateZ(-144deg);\n }\n  77% {\n    transform: rotateZ(-144deg);\n }\n  100% {\n    transform: rotateZ(-324deg);\n    opacity: 1;\n }\n}\n.preloader div:nth-child(6) {\n  transform: rotateZ(180deg);\n  animation: rotateCircle6 2s infinite linear;\n  z-index: 4;\n}\n@keyframes rotateCircle6 {\n  25% {\n    opacity: 0;\n }\n  25.0005% {\n    opacity: 1;\n    transform: rotateZ(-144deg);\n }\n  32% {\n    transform: rotateZ(-180deg);\n }\n  82% {\n    transform: rotateZ(-180deg);\n }\n  100% {\n    transform: rotateZ(-324deg);\n    opacity: 1;\n }\n}\n.preloader div:nth-child(7) {\n  transform: rotateZ(216deg);\n  animation: rotateCircle7 2s infinite linear;\n  z-index: 3;\n}\n@keyframes rotateCircle7 {\n  30% {\n    opacity: 0;\n }\n  30.0006% {\n    opacity: 1;\n    transform: rotateZ(-180deg);\n }\n  37% {\n    transform: rotateZ(-216deg);\n }\n  87% {\n    transform: rotateZ(-216deg);\n }\n  100% {\n    transform: rotateZ(-324deg);\n    opacity: 1;\n }\n}\n.preloader div:nth-child(8) {\n  transform: rotateZ(252deg);\n  animation: rotateCircle8 2s infinite linear;\n  z-index: 2;\n}\n@keyframes rotateCircle8 {\n  35% {\n    opacity: 0;\n }\n  35.0007% {\n    opacity: 1;\n    transform: rotateZ(-216deg);\n }\n  42% {\n    transform: rotateZ(-252deg);\n }\n  92% {\n    transform: rotateZ(-252deg);\n }\n  100% {\n    transform: rotateZ(-324deg);\n    opacity: 1;\n }\n}\n.preloader div:nth-child(9) {\n  transform: rotateZ(288deg);\n  animation: rotateCircle9 2s infinite linear;\n  z-index: 1;\n}\n@keyframes rotateCircle9 {\n  40% {\n    opacity: 0;\n }\n  40.0008% {\n    opacity: 1;\n    transform: rotateZ(-252deg);\n }\n  47% {\n    transform: rotateZ(-288deg);\n }\n  97% {\n    transform: rotateZ(-288deg);\n }\n  100% {\n    transform: rotateZ(-324deg);\n    opacity: 1;\n }\n}\n.preloader div:nth-child(10) {\n  transform: rotateZ(324deg);\n  animation: rotateCircle10 2s infinite linear;\n  z-index: 0;\n}\n@keyframes rotateCircle10 {\n  45% {\n    opacity: 0;\n }\n  45.0009% {\n    opacity: 1;\n    transform: rotateZ(-288deg);\n }\n  52% {\n    transform: rotateZ(-324deg);\n }\n  102% {\n    transform: rotateZ(-324deg);\n }\n  100% {\n    transform: rotateZ(-324deg);\n    opacity: 1;\n }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
